import {useApi} from "../Api";
import {SelectElementModelBE} from "../types/generic";

export const useTpUnitRepository = () => {
    const {GET} = useApi();

    const PATH = "/pricing/tp-unit";

    function getTpUnits(): Promise<SelectElementModelBE[]> {
        return GET(`${PATH}/list`);
    }

    return {getTpUnits};
};